module.exports = __webpack_public_path__ + "img/shoploading.d56e9f41.gif";